<template>
  <WsUpdate
    :modelName="modelName"
    :id="$route.params.id"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    titleKey="last_version.name"
  >
  </WsUpdate>
</template>

<script>
import model from "@/models/risk_template";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    // modelIdName: "risk_template_id",
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "風險評估資訊",
              fields: ["last_version"],
            },
          ],
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "分類設定",
              fields: [
                "area",
                "area_section",
                "system_class",
                "system_subclass",
              ],
            },
          ],
        },
        // {
        //   type: "infoCard",
        //   floors: [
        //     {
        //       title: "設定",
        //       remark: "隱藏的內容將不會顯示於使用者前台介面",
        //       fields: ["is_active"],
        //     },
        //   ],
        // },
      ],
    },
  }),
};
</script>